import React, { useRef, useEffect, useState } from "react";

import classNames from "classnames";

import { SingleReview } from "data/videoProductPage";
import { useWindowSize } from "usehooks-ts";

import { ProfilePic } from "~/components/common/ProfilePic";
import { checkLineNumber } from "~/components/videoProductPage/utils/checkLineNumber";

import * as styles from "./Reviews.css";

export const ReviewItem = ({ review }: { review: SingleReview }) => {
  const [showMore, setShowMore] = useState(false);

  const textBlockRef = useRef<HTMLParagraphElement>(null);
  const [truncatedText, setTruncatedText] = useState({
    content: review.reviewText,
    truncated: false,
  });
  const [lineNumber, setLineNumber] = useState(0);
  const { width } = useWindowSize();

  useEffect(() => {
    setLineNumber(checkLineNumber(textBlockRef.current, review.reviewText));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [width]);

  const showMoreHandler = () => {
    setShowMore(false);
  };

  const showLessHandler = () => {
    setShowMore(true);
  };

  useEffect(() => {
    if (lineNumber <= 4) {
      setTruncatedText({ content: review.reviewText, truncated: false });
      setShowMore(false);
      return;
    }

    if (!textBlockRef.current) return;

    setShowMore(true);
    const textNode = textBlockRef.current;
    textNode.textContent = review.reviewText;
    const { offsetHeight } = textNode;
    const lineHeight = parseFloat(getComputedStyle(textNode).lineHeight || "0");
    const maxHeight = 4 * lineHeight;

    if (offsetHeight > maxHeight) {
      let words = review.reviewText.split(" ");
      let tempText = "";

      while (textNode.offsetHeight > maxHeight) {
        words.pop();
        tempText = words.join(" ") + "...";
        textNode.innerText = tempText;
      }

      words = words.slice(0, words.length - 5);

      tempText = words.join(" ") + "...";

      setTruncatedText({ content: tempText, truncated: true });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lineNumber]);

  const handleTextExpansionClick = () => {
    setShowMore(!showMore);
  };

  return (
    <div className={styles.singleReview}>
      <div className={styles.reviewInfo}>
        <div className={styles.reviewAuthorImgBlock}>
          <div className={styles.imageContainer}>
            <ProfilePic
              className={styles.reviewAuthorImg}
              imageUrl={review.reviewerProfileImageURL || ""}
              firstName={review.reviewerName}
              size={40}
            ></ProfilePic>
          </div>
        </div>
        <div className={styles.reviewDateAuthor}>
          <div className={styles.authorName}>{review.reviewerName}</div>
        </div>
      </div>
      <div
        onClick={handleTextExpansionClick}
        className={classNames(styles.reviewTextBlock, truncatedText.truncated && styles.longReview)}
      >
        <p ref={textBlockRef} className={classNames(styles.reviewText)}>
          {showMore && truncatedText.truncated ? truncatedText.content : review.reviewText}
        </p>
        {showMore && truncatedText.truncated && (
          <span onClick={showMoreHandler} className={classNames(styles.reviewTextShowMore)}>
            More
          </span>
        )}
        {!showMore && truncatedText.truncated && (
          <span onClick={showLessHandler} className={styles.reviewTextShowMore}>
            Less
          </span>
        )}
      </div>
    </div>
  );
};
